export const directaThemeColors = {
  primary: '#004DD8',
  secondary: '#7ee16b',
  tertiary: '#6BBF5B',
  h1: '#000',
  success: '#96DF7A',
  info: '#3BCFD5',
  warning: '#F3B258',
  danger: '#DD3570',
  dark: '#1E1E1E',
  activeColor: '#FFFFFF',
  contrastActiveColor: '#000000',
  loaderFirst: '#7EE16B',
  loaderSecond: '#76D872',
  loaderThird: '#014ED8',
  borderColor: '#D9D9D9',
  roundedGrey: '#7ee16b',
};
